<template>
  <div>
    <div class="col banner-area">
      <div class="row" style="margin-top: 150px">
        <div class="container">
          <div class="col-lg-5 banner-side">
            <div class="row">
              <span class="content-center text-center mb-font" style="font-size:1.75rem;font-weight:500;">
                <strong>Shortlist candidates from Video profiles</strong>
              </span>
            </div>
            <div class="row" style="margin-top:50px;">
              <p class="content-center" style="color: #000; text-align: center">Hire best matching talents from candidate video profiles #visume &amp; make your pre-screening virtually</p>
            </div>
            <div class="row" style="margin-top:30px;">
              <div class="col text-center">
                <a type="button" class="btn btn-primary content-center" style="font-size:1rem;font-weight: 400;color:white" href="/recruit/post-job" target="blank">Post a job</a>
              </div>
            </div>
          </div>
          <div class="col-lg-6 banner-image">
            <picture>
              <img :src="$S3_url+'/Assets/images/hire.png'" class="banner_img"/>
            </picture>
          </div>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="container">
          <p class="content-center" style="text-align: center">
            <strong> Need help ?</strong> Contact our expert team
            <a href="mailto:recruit@hireclap.com" style="color: #03a9f4">recruit@hireclap.com</a> /  +91 9037 156 256
          </p>
        </div>
      </div>
    </div>
    <div class="col features">
      <div class="container text-center">
        <h2 class="content-center" style="color: #000">How to find best talents ?</h2>
        <p class="content-center" style="color: #000; text-align: center">
          <a href="/recruit/post-job" style="color: #03a9f4" target="noopener">Post your job</a> - our recruitment tools make your hiring faster &amp; accurate
        </p>
        <div class="row mt-12">
          <div class="card-deck">
            <div class="card text-center border-0">
              <img :src="$S3_url+'/Assets/images/video_profile.png'" class="card-img-top card-img" alt="..." style="width: 170px; margin: 0 auto"/>
              <div class="card-body">
                <h5 class="card-title" style="font-weight: 600">Video Profile</h5>
                <p class="card-text">Candidates Video profile - More detailing about the candidate, skills , preferences &amp; why to hire them</p>
                <p class="card-text"><a href="#"></a></p>
              </div>
            </div>
            <div class="card text-center border-0">
              <img :src="$S3_url+'/Assets/images/engaged_candidate.png'" class="card-img-top card-img" alt="..." style="width: 170px; margin: 0 auto"/>
              <div class="card-body">
                <h5 class="card-title" style="font-weight: 600">Active &amp; Engaged Candidates</h5>
                <p class="card-text">Reachout to active candidate pool.Engage them with questionnaires to understand more about job fitment</p>
                <p class="card-text"><a href="#"></a></p>
              </div>
            </div>
            <div class="card text-center border-0">
              <img :src="$S3_url+'/Assets/images/adv_assessments.png'" class="card-img-top card-img" alt="..." style="width: 170px; margin: 0 auto"/>
              <div class="card-body">
                <h5 class="card-title" style="font-weight: 600">Advance Assessments</h5>
                <p class="card-text"> Evaluate candidates with advance assessments , based on your job roles</p>
                <p class="card-text"><a href="#"></a></p>
              </div>
            </div>
            <div class="card text-center border-0">
              <img :src="$S3_url+'/Assets/images/app_dashboard.png'" class="card-img-top card-img" alt="..." style="width: 170px; margin: 0 auto"/>
              <div class="card-body">
                <h5 class="card-title" style="font-weight: 600">Application Dashboard</h5>
                <p class="card-text"> Dashboard to manage all applicants- to shortlist , rate, connect &amp; to decide your final hiring</p>
                <p class="card-text"><a href="#"></a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col more">
      <div class="container">
        <h3 class="content-center h2_replace" style="text-align: center">More recruitment products</h3>
        <div class="row mt-12">
          <div class="card-deck">
            <div class="card">
              <div class="card-body">
                <h5 class="card-title" style="text-align: center; color: #007bff">Resume Search</h5>
                <p class="card-text"> Search resume based on your specific requirement, location &amp; matching filters.</p>
                <p class="card-text">Unlimited resume search.</p>
                <p class="card-text"> Send messages, emails to shortlisted candidates . Resume credits deducted on profiles downloaded / viewed</p>
              </div>
              <div class="card-footer">
                <div style="text-align: center">
                  <a href="/recruit/contact-us" target="noopener" class="btn btn-primary text-white">Learn More</a>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <h5 class="card-title" style="text-align: center; color: #007bff"> End to End Consulting</h5>
                <p class="card-text">Share the requirement with us - our expert recruitment consulting team will invite applications , shortlist , follow up &amp; close the open positions for you.</p>
                <p class="card-text">Suitable for organisations with more than 10 open positions </p>
              </div>
              <div class="card-footer">
                <div style="text-align: center">
                  <a href="/recruit/contact-us" target="noopener" class="btn btn-primary text-white">Contact Us</a>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <h5 class="card-title" style="text-align: center; color: #007bff"> Online Assessment</h5>
                <p class="card-text"> New age Online Assessment platform to evaluate skills,abilities &amp; subject knowledge</p>
                <p class="card-text">You can create</p>
                <ul>
                  <li>Objective Assessments</li>
                  <li>Subjective Assessment</li>
                  <li>Psychometric Assessment</li>
                  <li>Coding Assessment</li>
                </ul>
              </div>
              <div class="card-footer">
                <div style="text-align: center">
                  <a href="https://www.assessengine.com/" target="noopener" class="btn btn-primary text-white">Subscribe</a>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <h5 class="card-title" style="text-align: center; color: #007bff"> Skilled Talent @Zero Cost </h5>
                <div>Hire from the largest pool of trained & certified candidates</div>
                <div>by leading training/upskilling companies across the country</div>
                <div>SkillHire is the one-stop platform to hire skilled and job-ready candidates for your organisation.</div>
                <div>Find your ideal match, faster at zero cost.</div>
              </div>
              <div class="card-footer">
                <div style="text-align: center">
                  <a href="/recruit/post-job?src=skillhire" target="noopener" class="btn btn-primary text-white">Start hiring</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-12">
          <div class="col">
            <p class="text-center">
              Looking for custom packages ? or your hiring numbers are high ?
              <a href="/recruit/contact-us" target="noopener" style="color: #03a9f4"> Contact us</a>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="col clients" style="background-color: #fafafa">
      <div class="container mt-12">
        <span class="text-center h2_replace" style="display:block;">Our clients</span>
        <p class="text-center" style="color: gray"> Companies from all major industries using our support to hire candidates</p>
        <div class="row mt-12 mb-12">
          <div class="card-deck">
            <div class="card">
              <img :src="$S3_url+'/Assets/images/jsw.png'" class="card-img-top clients-img" alt="..." style="width: 200px;margin: 0 auto;height: 115px;"/>
              <div class="card-body">
                <p class="card-text mt-5"> JSW Cement used our support to invite &amp; shortlist candidates for the entry level hiring .Candidate evaluation &amp; shortlisting done easily through the tech platform</p>
              </div>
            </div>
            <div class="card">
              <img :src="$S3_url+'/Assets/images/manipal_global.jpeg'" class="card-img-top clients-img" alt="..." style="width: 200px;margin: 0 auto;height: 115px;"/>
              <div class="card-body">
                <p class="card-text mt-5 mb-2"> Manipal global is India’s leading upskilling organisation.Manipal Global associated for candidate sourcing for its various job assured upskilling programs</p>
              </div>
            </div>
            <div class="card">
              <img :src="$S3_url+'/Assets/images/tata_insurance.jpg'" class="card-img-top clients-img" alt="..." style="width: 200px;margin: 0 auto;height: 115px;"/>
              <div class="card-body">
                <p class="card-text mt-5 mb-2"> Leading insurance provider in India. Candidate sourcing evaluation done using our platform. Helped to quickly shortlist the best from candidate pool</p>
              </div>
            </div>
            <div class="card">
              <img :src="$S3_url+'/Assets/images/tata_chemicals.jpg'" class="card-img-top clients-img" alt="..." style="width: 200px;margin: 0 auto;height: 115px;"/>
              <div class="card-body">
                <p class="card-text mt-5 mb-2"> TCL is an Indian global company interested in chemicals.TCL used our campus recruitment support to invite online applications &amp; online assessments from premium colleges pan India basis</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col text-center">
      <div class="container">
        <div class="text-center" style="margin-top:160px; margin-bottom:30px;">
          <span class="content-center" style="font-weight:600">Start your hiring</span>
        </div>
        <div class="text-center" style="margin-bottom:160px">
          <a class="btn btn-primary content-center" style="font-size:1rem;font-weight: 400;color:white" href="/recruit/post-job" target="blank">Post a Job</a>
        </div>  
      </div> 
    </div>
    <!-- <div class="col about-hireclap" style="background-color: #fafafa; border-top:1px solid lightgray">
      <div class="container" style="padding: 50px">
        <div class="row" style="padding: 20px">
        <h5><strong>About Hireclap</strong></h5>
      <p>Shortlist candidates from Video profiles #Visume. Hire best matching talents from candidate video profiles &amp; make your pre-screening virtually.</p>
      <p>#Visume is a candidate video resume - more detailing about the candidate , skills preferences &amp; why to hire. Reachout to active candidate pool.Engage them, evaluate and make the hiring decision data driven with the help of these insights </p>
        </div>
          <div class="card-deck">
              <div class="card" style="background: transparent;border: none;">
                <div class="card-body pr-0">
                  <h5 class="card-title"><strong>Need Help?</strong></h5>
                  <p class="card-text"></p>
                  <div class="row" style="height:30px;"></div>
                    <div class="btn btn-primary mb-5" data-toggle="modal" data-target="#staticBackdrop01" style="border: 1px solid #007bff;color: #007bff;background-color: transparent;" @click.prevent="openModal('contact_us')">Contact support team</div>
                  <div class="row gap20"></div>
                <a class="" href="mailto:recruit@hireclap.com"><u>recruit@hireclap.com</u></a><br>
                <p class="about-hireclap">+91 9037 156 256</p>
                </div>
              <b-modal id="contact-us" ref="contact-us" title="Contact Us" no-close-on-backdrop>
                <div class="container">
                  <form>
                    <div class="form-group">
                      <input type="text" class="form-control" id="name" aria-describedby="nameHelp" placeholder="Name">
                    </div>
                    <div class="form-group">
                    <input type="email" class="form-control" id="email" aria-describedby="emailHelp" placeholder="Email">
                    </div>
                    <div class="form-group">
                      <div class="input-group">
                        <div class="input-group-prepend"><span class="input-group-text">+91</span></div>
                      <input type="number" class="form-control rounded-right" required="" placeholder="Mobile Number">
                      <div class="invalid-feedback">Please enter a valid phone number</div>
                    </div>
                  </div>
                  <div class="form-group">
                    <textarea type="text" class="form-control" id="exampleInputEmail1" rows="4" cols="50" aria-describedby="messageHelp" placeholder="Comment"></textarea>
                  </div>  
                </form>
              </div>
              </b-modal>
              </div>
              <div class="card" style="background: transparent;border: none;">
                <div class="card-body">
                  <h5 class="card-title"><strong>Resources</strong> </h5>
                  <p class="card-text">
                  <a class="flink" href="/">FAQ</a><br>
                  <a class="flink" href="/terms">Terms &amp; conditions</a><br>
                  <a class="flink" href="/">Advertise with us</a><br>
                  <a class="flink" href="/">Business Enquiry</a><br>
                  <a class="flink" href="/jobs">Find Jobs</a><br>
                </p>
                </div>
              </div>
              <div class="card" style="background: transparent;border: none;">
                <div class="card-body">
                  <h5 class="card-title"><strong>Employer Zone</strong></h5>
                  <p class="card-text">
                <a class="flink" href="/">Free Job Posting</a><br>
                <a class="flink" href="/">Recruitment Package</a><br>
                <a class="flink" href="/">Resume Search</a><br>
                <a class="flink" href="/">End to End Consulting</a><br>
                <a class="flink" href="https://www.assessengine.com/" target="noopener">Online Assessment <span><i class="mdi mdi-star-circle" style="color:#007bff"></i></span></a><br>
                <a class="flink" href="/">Application Management System</a><br>
                </p>
                </div>
              </div>
              <div class="card" style="background: transparent;border: none;">
                <div class="card-body">
                  <h5 class="card-title"><strong>Institute Zone</strong></h5>
                  <p class="card-text">
                <a class="flink" href="https://forms.hireclap.com/institute-registration" target="noopener">List your Institute</a><br>
                <a class="flink" href="https://dev.hireclap.com/">Marketing Campaigns</a><br>
                <a class="flink" href="https://dev.hireclap.com/">Virtual Placement Cell(VPCell)</a><br>
                <a class="flink" href="https://dev.hireclap.com/">Virtual Campus Placement</a><br>
                </p>
                </div>
              </div>
            </div>
      </div> 
    </div> -->
    
  </div>
</template>


<script>
import Actions from '../libraries/apiActions.js';
export default {
  name: "home",
  mounted() {

  },
  data(){
    return{
      modals:{ 
        open:'exit',
      },
      action: new Actions(),
      valid:false,
      contact:{
        name: null,
        email: null,
        mobile: null,
        comment:null,
      },
      sentFlag:false,
      emailRules:[
        v => !!v || 'Required',
        v => /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Enter valid email',
      ],
      mobileRules:[
        v => !!v || 'Required',
        v => !/\D/g.test(v) || 'Enter valid mobile number',
        v => (v && v.length == 10) || 'Enter 10 digit mobile number'
      ],
    }
  },
  methods:{
    openModal : function(type= ''){
      this.open = type == "" ? this.open : type;
        if (this.open == "contact_us") {
          this.$refs["contact-us"].show();
        }
      this.modals.open = 'exit';
      this.modals.open = type;
    },
    hideModal(){
      this.$refs["contact-us"].hide();
    },
    submitContact(){
      this.valid = this.$refs.form.validate();
      if(this.valid){
        this.action.sendContact(this.contact).then(res => {
          if(res.status == 1){
            this.sentFlag = true;
            setTimeout(() => {
            this.$refs['contact-us'].hide();
            },3000);
          }
        })
      }
    },
    postJob(){
      // if(this.$cookies.get('hire-employer')){
        window.open('/recruit/post-job','_blank');
      // }else{
      //   window.open('/recruit/post-job','_blank');
      // }
    }
  }
};
</script>

<style scoped>
.banner_img {
  display: block;
  width: 100%;
}
.banner-side {
  float: left;
}
.banner-image {
  float: right;
}
.h2_replace{
  font-size: 2rem !important;
  font-weight: 500 !important;
  line-height: 1.2 !important;
  margin-bottom:0.5rem !important;
}
.error--text fieldset{
  border: 2px solid #ff5252 !important;
}
.v-text-field__details{
  display: block !important;
}
.v-input__slot{
  margin-bottom: 5px !important;
}
</style>